import * as react from "react";
import { errorMsg, spinner, icon, validatedTextarea, switch$ } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { Page, TextEditModel__get_CanSubmit, Msg } from "./Types.fs.js";
import { Option, ISize, column } from "../../../fable_modules/Fulma.3.0.0/Layouts/Column.fs.js";
import { Screen } from "../../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { empty as empty_1, map, singleton } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { DangerousHtml, DOMAttr, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { equals } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";

export function maintenanceActiveSwitch(model, dispatch) {
    const children_2 = [react.createElement("label", {
        className: "label",
    }, "Wartungsmodus aktiv"), switch$(model.MaintenanceActive, (b) => {
        dispatch(new Msg(7, [b]));
    }, "")];
    return react.createElement("div", {
        className: "field",
    }, ...children_2);
}

export function editBox(model, dispatch, navigateTo) {
    let children_30, children_4, children_2, children, children_28;
    const isLoading = model.Sending ? " is-loading" : "";
    return column(singleton(new Option(0, [new Screen(0, []), new ISize(10, [])])), singleton((children_30 = [(children_4 = [(children_2 = [(children = [toText(printf("%s bearbeiten"))(model.Key)], react.createElement("b", {}, ...children))], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_28 = toList(delay(() => {
        let children_8, children_6;
        return append((model.Key === "Wartungsmeldung") ? singleton_1((children_8 = [(children_6 = [maintenanceActiveSwitch(model, dispatch)], react.createElement("div", {
            className: "column is-12",
        }, ...children_6))], react.createElement("div", {
            className: "columns",
        }, ...children_8))) : empty(), delay(() => {
            let children_14, children_12, children_10;
            return append(singleton_1((children_14 = [(children_12 = [(children_10 = [validatedTextarea((arg_1) => {
                dispatch(new Msg(6, [arg_1]));
            }, "Text", "Text", "", "is-big", model.Content)], react.createElement("div", {
                className: "info-block",
            }, ...children_10))], react.createElement("div", {
                className: "column is-12",
            }, ...children_12))], react.createElement("div", {
                className: "columns",
            }, ...children_14))), delay(() => {
                let children_26, children_24, children_18, props_16, children_22, children_20;
                return singleton_1((children_26 = [(children_24 = [(children_18 = [(props_16 = [new HTMLAttr(65, ["button is-link" + isLoading]), new HTMLAttr(79, [!TextEditModel__get_CanSubmit(model)]), new DOMAttr(40, [(_arg) => {
                    dispatch(new Msg(9, []));
                }])], react.createElement("button", keyValueList(props_16, 1), "Speichern"))], react.createElement("div", {
                    className: "info-block is-pulled-right",
                }, ...children_18)), (children_22 = [(children_20 = [model.IsDirty ? "Abbrechen" : "Zurück"], react.createElement("button", {
                    className: "button is-danger is-link",
                    onClick: (_arg_1) => {
                        navigateTo(new Page(0, []));
                    },
                }, ...children_20))], react.createElement("div", {
                    className: "info-block",
                }, ...children_22))], react.createElement("div", {
                    className: "column is-12",
                }, ...children_24))], react.createElement("div", {
                    className: "columns",
                }, ...children_26)));
            }));
        }));
    })), react.createElement("div", {
        className: "card-body",
    }, ...children_28))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto",
    }, ...children_30))));
}

export function previewBox(model) {
    let children_10, children_4, children_2, children_8, props_6;
    return column(singleton(new Option(0, [new Screen(0, []), new ISize(10, [])])), singleton((children_10 = [[(children_4 = [(children_2 = [react.createElement("b", {}, "Vorschau")], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_8 = [(props_6 = [new HTMLAttr(65, ["content"]), new DOMAttr(0, [new DangerousHtml(model.TextAsHtml)])], react.createElement("div", keyValueList(props_6, 1)))], react.createElement("div", {
        className: "card-body",
    }, ...children_8))]], react.createElement("div", {
        className: "flat-card profile-info-card is-auto",
    }, ...children_10))));
}

export function editPage(model, dispatch, navigateTo) {
    const children = [editBox(model, dispatch, navigateTo), previewBox(model)];
    return react.createElement("div", {
        className: "columns is-multiline",
    }, ...children);
}

export function tableRow(navigateTo, textKey) {
    let children_4, children_2;
    const children_6 = [react.createElement("td", {}, textKey), (children_4 = [(children_2 = [icon("fas fa-edit")], react.createElement("a", {
        onClick: (_arg) => {
            navigateTo(new Page(1, [textKey]));
        },
        title: "bearbeiten",
    }, ...children_2))], react.createElement("td", {}, ...children_4))];
    return react.createElement("tr", {
        className: "",
    }, ...children_6);
}

export function table(textInfoList, navigateTo) {
    let children_6, children_4, children_8;
    const children_10 = [(children_6 = [(children_4 = [react.createElement("th", {}, "Text-Schlüssel"), react.createElement("th", {}, "Aktionen")], react.createElement("tr", {}, ...children_4))], react.createElement("thead", {}, ...children_6)), (children_8 = map((textKey) => tableRow(navigateTo, textKey), textInfoList), react.createElement("tbody", {}, ...children_8))];
    return react.createElement("table", {
        className: "table table-striped responsive-table",
    }, ...children_10);
}

export function listPage(model, navigateTo) {
    let children_8;
    const children_10 = [(children_8 = toList(delay(() => {
        let children_6, children_4;
        return singleton_1((children_6 = [(children_4 = toList(delay(() => {
            let matchValue;
            return singleton_1((matchValue = model.TextInfoList, (matchValue.tag === 1) ? spinner : ((matchValue.tag === 2) ? errorMsg("Fehler beim Laden der Texte!") : ((matchValue.tag === 3) ? (equals(matchValue.fields[0], empty_1()) ? react.createElement("div", {}, "Keine Texte vorhanden") : table(matchValue.fields[0], navigateTo)) : react.createElement("div", {})))));
        })), react.createElement("div", {
            className: "card-body",
        }, ...children_4))], react.createElement("div", {
            className: "flat-card profile-info-card is-auto",
        }, ...children_6)));
    })), react.createElement("div", {
        className: "column is-12",
    }, ...children_8))];
    return react.createElement("div", {
        className: "columns is-multiline",
    }, ...children_10);
}

export function view(model, dispatch, navigateTo) {
    if (model.tag === 1) {
        return editPage(model.fields[0], dispatch, (arg_1) => {
            navigateTo(arg_1);
        });
    }
    else {
        return listPage(model.fields[0], (arg) => {
            navigateTo(arg);
        });
    }
}

//# sourceMappingURL=View.fs.js.map
